import { useEffect, useRef, useState } from "react";
import { TextField } from "@mui/material";
import { useBoolState } from "@dvrt/react-tools";
import InputMenu from "./InputMenu";
import { useChatMessages } from "../../chatMessages";
import { containerSpacing } from "./styles";

const Input = () => {
    const [message, setMessage] = useState("");
    const [disabled, disable, enable] = useBoolState();
    const inputRef = useRef<HTMLInputElement>(null);
    const { sendMessage } = useChatMessages();

    const onEnter = async () => {
        if (message === "") return;

        setMessage("");

        disable();

        await sendMessage(message);

        enable();
    };

    useEffect(() => {
        if (!disabled && inputRef.current) inputRef.current.focus();
    }, [disabled]);

    return (
        <div style={{ margin: `0 ${containerSpacing} ${containerSpacing}` }}>
            <TextField
                inputRef={inputRef}
                value={message}
                disabled={disabled}
                fullWidth
                size="small"
                margin="dense"
                variant="outlined"
                multiline
                onChange={(event) => setMessage(event.target.value)}
                onKeyPress={(event) => {
                    if (event.key === "Enter" && !event.shiftKey) onEnter();
                }}
                InputProps={{
                    endAdornment: <InputMenu />,
                    style: {
                        fontSize: 14,
                    },
                }}
            />
        </div>
    );
};

export default Input;
